/*******************************************************************************
REVEAL THE SELECTED FILTER FOR A SET OF FILTER LINKS
On page load we need to drill down to the selected filter if it's not at the top level.
*******************************************************************************/

export default function revealSelectedFilter(i, filterLinkSet) {
    const $filterLinkSet = $(filterLinkSet);
    const moreButtonText = $filterLinkSet.data('moreButton') || 'More Filters';
    const $selectedFilter = $filterLinkSet.find('.is-selected');
    const selectedLevel = +$selectedFilter.data('level') || 1;
    const selectedParent = $selectedFilter.data('parent');

    // Hide all the filter links to start
    $filterLinkSet.find('.filter-link').addClass('hide');

    if (selectedLevel > 1) {
        const $title = $filterLinkSet.parents('.filter-links-wrapper').siblings('.filter-links-title');

        // Add the active sub nav wrapper class and the More Filters button
        $filterLinkSet.parents('.filter-links-wrapper').addClass('is-showing-sub-nav');
        $filterLinkSet.before(`<button class="more-filter-links">${moreButtonText}</button>`);

        // Only show the filter links that are in the same group as the selected filter
        $(`.filter-link[data-level="${selectedLevel}"][data-parent="${selectedParent}"]`).removeClass('hide');

        // Update the sub-title
        let subTitle = selectedParent;
        if (selectedLevel === 3) {
            subTitle = `${$(`.filter-link[data-name="${selectedParent}"]`).data('parent')}: ${selectedParent}`;
        }
        $title.html(`${$title.html()}<span class="filter-links-sub-title">${subTitle}</span>`);
    }
    else {
        $filterLinkSet.find('.filter-link:not(.is-sub-link)').removeClass('hide');
    }
}
